import { Injectable } from '@angular/core';
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  CanActivate
} from '@angular/router';

import { Auth } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private auth: Auth,
    private router: Router
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state?: RouterStateSnapshot
  ) {
    if (this.auth.loggedIn()) {
      return true;
    } else {
      // Safely handle undefined state
      const url = state && state.url ? state.url : (this.router?.url || '/');
      this.router.navigate(['/unauthorized'], {
        queryParams: { state: url }
      });
      return false;
    }
  }
}
